export enum TimesheetTypes {
    ACTUAL = 'Actual',
    PLANNED = 'Planned',
}
